import { AgentFile } from "../../Types/common";

export function SplitFileIntoChuncks(file: File, chunckSize?: number): any[] {
    const chunckSizes = chunckSize ? chunckSize : 5 * 1024 * 1024
    const chuncks = []
    var start = 0
    while (start < file.size) {
        const end = start + chunckSizes;
        chuncks.push(file.slice(start, end));
        start = end;
    }
    return chuncks
}



export function GetFileName(file: File) {
    let name
    // if (ISFile(fileItem)) {
    //     name = fileItem.name
    // } else {
    //     name = fileItem.name ? fileItem.name : ''
    // }
    name = file.name ? file.name : ""
    var extn = name.split(".")[1];
    var filename;
    if (name.split(".")[0].trim().length > 10) {
        filename = name.length > 10 ? name.substring(0, 10) + "... ." + extn : name;

    } else {
        filename = name;
    }
    return { filename, fullfilename: name };
};

export function ISAgentFile(file: any): file is AgentFile {
    return 'trainingStatus' in file
}

export function GetFileSize(file: any | string) {
    let size
    if (ISAgentFile(file)) {
        size = file.fileSize
    } else {
        size = file.size ? file.size : 0
        size = (size / (1024 * 1024)).toFixed(2)
        size = `${size} MB`
    }
    return size
};